import { render } from "./AIEngineeringPage.vue?vue&type=template&id=4be0cfa8"
import script from "./AIEngineeringPage.vue?vue&type=script&lang=js"
export * from "./AIEngineeringPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__